var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,1H10.037V4H8V1H6V4H3.963V1H2A2,2,0,0,0,0,3V5A2,2,0,0,0,2,7H22a2,2,0,0,0,2-2V3A2,2,0,0,0,22,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9H10.037v3H8V9H6v3H3.963V9H2a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V11A2,2,0,0,0,22,9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17H10.037v3H8V17H6v3H3.963V17H2a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V19A2,2,0,0,0,22,17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.e1c30f1b797ea346534f1dad317e7a05.svg";
export { ForwardRef as ReactComponent };